import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { LockerDetailsInput } from '../../../../../../../../../public-session/src/graphql';

declare var easyPack: {
  init: (args: any) => void;
  mapWidget: (
    string,
    callback: (point: {
      name: string;
      address: {
        line1: string;
        line2: string;
      };
    }) => void,
  ) => void;
};

@Component({
    selector: 'lib-easy-pack24-locker-picker',
    templateUrl: './easy-pack24-locker-picker.component.html',
    styleUrls: ['./easy-pack24-locker-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EasyPack24LockerPickerComponent implements OnInit {
  constructor(private elementRef: ElementRef) {}
  @Output() picked = new EventEmitter<LockerDetailsInput>();
  iframeSrc = 'https://sesje.zalamo.com/assets/easypack.html';

  private messageHandler = (event: MessageEvent) => {
    // If you want to limit the origin, check `event.origin` here
    try {
      const data = JSON.parse(event.data);
      // Because "point" from EasyPack has { name, address: { line1, line2 } }
      // adapt if you want to shape it to your LockerDetailsInput interface
      const lockerDetails: LockerDetailsInput = {
        name: data.name,
        address: {
          line1: data.address.line1,
          line2: data.address.line2,
        },
      };
      this.picked.emit(lockerDetails);
    } catch (e) {
      // Handle or ignore any non-JSON messages
      console.warn('Non-JSON message received from iframe:', event.data);
    }
  };

  ngOnInit(): void {
    // Listen for message events from the child iframe
    window.addEventListener('message', this.messageHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler);
  }
}
